import { render, staticRenderFns } from "./FreePlanSection.vue?vue&type=template&id=2b94660b&scoped=true&"
import script from "./FreePlanSection.vue?vue&type=script&lang=js&"
export * from "./FreePlanSection.vue?vue&type=script&lang=js&"
import style0 from "./FreePlanSection.vue?vue&type=style&index=0&id=2b94660b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b94660b",
  null
  
)

export default component.exports